import { MaskedLines } from "./motion";

// Hero commun des pages intérieures : titre masqué ligne par ligne + surtitre.
export default function PageHero({ eyebrow, titleLines, description, dark = false, children }) {
  return (
    <section
      className={`grain relative overflow-hidden pb-16 pt-32 sm:pb-24 sm:pt-40 ${
        dark ? "bg-nuit-900 text-white" : "bg-white text-nuit-900"
      }`}
    >
      {dark && (
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(60% 50% at 70% 10%, rgba(22,119,255,0.22) 0%, transparent 70%), radial-gradient(40% 40% at 15% 85%, rgba(22,119,255,0.12) 0%, transparent 70%)",
          }}
          aria-hidden="true"
        />
      )}
      <div className="container-nv relative">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="mt-4 font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLines lines={titleLines} />
        </h1>
        {description && (
          <p className={`mt-6 max-w-2xl text-base leading-relaxed sm:text-lg ${dark ? "text-white/70" : "text-steel"}`}>
            {description}
          </p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
